import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { GradeBadge, StatusChip } from "@/components/Badges";
import { Search, ShieldCheck } from "lucide-react";

export default function AuditMode() {
  const { t } = useLang();
  const nav = useNavigate();
  const [looms, setLooms] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/looms").then((r) => setLooms(r.data)); }, []);

  const filtered = looms.filter((l) =>
    !q ||
    (l.loom_number || "").toLowerCase().includes(q.toLowerCase()) ||
    (l.weaver_name || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div>
      <div className="eyebrow">Audit</div>
      <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>Audit Mode</h1>
      <p className="text-sm text-[#4A627A] mt-1 max-w-2xl">
        Perform an unannounced inspection on any loom. If your grade differs from the inspector's most recent grade, a mismatch is logged automatically.
      </p>
      <div className="mt-3 flex items-center gap-2">
        <Search size={16} className="text-[#7C8E9E]" />
        <input
          data-testid="audit-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search loom / weaver"
          className="h-10 px-2 border border-[#1B3A5C]/15 rounded-md text-sm flex-1 max-w-md"
        />
      </div>
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {filtered.map((l) => (
          <div key={l.id} data-testid={`audit-loom-${l.loom_number}`} className="hag-surface p-4">
            <div className="flex items-center justify-between">
              <div className="font-bold" style={{ color: "var(--brand-navy)" }}>{l.loom_number}</div>
              <div className="flex gap-1"><StatusChip status={l.status} /><GradeBadge grade={l.last_grade} /></div>
            </div>
            <div className="text-sm">{l.weaver_name}</div>
            <div className="text-xs text-[#7C8E9E]">Zone {l.zone || "?"} · Last visit: {l.last_visit_date ? new Date(l.last_visit_date).toLocaleDateString() : "—"}</div>
            <button
              data-testid={`audit-start-${l.loom_number}`}
              onClick={() => nav(`/inspector/loom/${l.id}/inspect?audit=1`)}
              className="mt-3 w-full h-10 rounded-md font-semibold text-white flex items-center justify-center gap-2"
              style={{ background: "var(--brand-navy)" }}
            >
              <ShieldCheck size={16} /> Start audit
            </button>
          </div>
        ))}
        {filtered.length === 0 && <div className="text-sm text-[#7C8E9E]">No looms.</div>}
      </div>
    </div>
  );
}
